import { BaseRouteService } from "./BaseRouteService"; // Zorg ervoor dat je het pad goed hebt ingesteld

export class LeaderboardService extends BaseRouteService {
    private API_URL: string = "leaderboard"; // Veronderstel dat de basis-URL al in je BaseRouteService staat

    // Methode om gamegegevens op te slaan en te controleren of er een nieuwe topscore is
    public async fetchGameData(
        userId: number,
        ending: "good" | "bad",
        itemsCollected: number,
        totalScore: number
    ): Promise<{ success: boolean; isNewTopScore: boolean }> {
        console.log("Saving game data...", { userId, ending, itemsCollected, totalScore });

        const response: {
            success: boolean;
            isNewTopScore: boolean;
        } = await this.postJsonApi<
            { success: boolean; isNewTopScore: boolean },
            { userId: number; ending: "good" | "bad"; itemsCollected: number; totalScore: number }
        >(
            `${this.API_URL}/saveGameData`,
            { userId, ending, itemsCollected, totalScore }
        );

        return {
            success: response.success,
            isNewTopScore: response.isNewTopScore,
        };
    }

    public async fetchLeaderboard(): Promise<
        { username: string; items_collected: number; ending: string; total_score: number }[]
    > {
        console.log("Fetching leaderboard data...");

        const response: {
            username: string;
            items_collected: number;
            ending: string;
            total_score: number;
        } | {
            username: string;
            items_collected: number;
            ending: string;
            total_score: number;
        }[] = await this.getJsonApi<
          { username: string; items_collected: number; ending: string; total_score: number } |
          { username: string; items_collected: number; ending: string; total_score: number }[]
        >(`${this.API_URL}/leaderboardInfo`);

        // Zorg ervoor dat het altijd een array is
        return Array.isArray(response) ? response : [response];
    }

    // Haal de eindscore op met alle ontbrekende velden
    public async fetchFinalScore(): Promise<{
        itemsCollected: number;
        pointsPerItem: number;
        itemsScore: number;
        goodEnd: boolean;
        goodEndPoints: number;
        badEndPoints: number;
        endPoints: number;
        totalScore: number;
    } | null> {
        console.log("Fetching final score...");

        return this.getJsonApi<{
            itemsCollected: number;
            pointsPerItem: number;
            itemsScore: number;
            goodEnd: boolean;
            goodEndPoints: number;
            badEndPoints: number;
            endPoints: number;
            totalScore: number;
        }>(`${this.API_URL}/finalScore`);
    }

    // ✅ Nieuwe functie: Haal de gameStarted-status op
    public async fetchGameStarted(): Promise<boolean> {
        console.log("Fetching gameStarted status...");

        const response: {
            gameStarted: boolean;
        } = await this.getJsonApi<{ gameStarted: boolean }>(`${this.API_URL}/game-started`);
        return response.gameStarted;
    }
}

// import { BaseRouteService } from "./BaseRouteService"; // Zorg ervoor dat je het pad goed hebt ingesteld

// export class LeaderboardService extends BaseRouteService {
//     private API_URL: string = "leaderboard"; // Veronderstel dat de basis-URL al in je BaseRouteService staat

//     // Methode om gamegegevens op te slaan en te controleren of er een nieuwe topscore is
//     public async fetchGameData(
//         userId: number,
//         ending: "good" | "bad",
//         itemsCollected: number,
//         totalScore: number
//     ): Promise<{ success: boolean; isNewTopScore: boolean }> {
//         console.log("Saving game data...", { userId, ending, itemsCollected, totalScore });

//         const response: {
//             success: boolean;
//             isNewTopScore: boolean;
//         } = await this.postJsonApi<
//             { success: boolean; isNewTopScore: boolean },
//             { userId: number; ending: "good" | "bad"; itemsCollected: number; totalScore: number }
//         >(
//             `${this.API_URL}/saveGameData`,
//             { userId, ending, itemsCollected, totalScore }
//         );

//         return {
//             success: response.success ?? false,
//             isNewTopScore: response.isNewTopScore ?? false,
//         };
//     }

//     public async fetchLeaderboard(): Promise<
//         { username: string; items_collected: number; ending: string; total_score: number }[]
//     > {
//         console.log("Fetching leaderboard data...");

//         const response: {
//             username: string;
//             items_collected: number;
//             ending: string;
//             total_score: number;
//         } | {
//             username: string;
//             items_collected: number;
//             ending: string;
//             total_score: number;
//         }[] = await this.getJsonApi<
//           { username: string; items_collected: number; ending: string; total_score: number } |
//           { username: string; items_collected: number; ending: string; total_score: number }[]
//         >(`${this.API_URL}/leaderboardInfo`);

//         // Zorg ervoor dat het altijd een array is
//         return Array.isArray(response) ? response : [response];
//     }

//     // Haal de eindscore op met alle ontbrekende velden
//     public async fetchFinalScore(): Promise<{
//         itemsCollected: number;
//         pointsPerItem: number;
//         itemsScore: number;
//         goodEnd: boolean;
//         goodEndPoints: number;
//         badEndPoints: number;
//         endPoints: number;
//         totalScore: number;
//     } | null> {
//         console.log("Fetching final score...");

//         return this.getJsonApi<{
//             itemsCollected: number;
//             pointsPerItem: number;
//             itemsScore: number;
//             goodEnd: boolean;
//             goodEndPoints: number;
//             badEndPoints: number;
//             endPoints: number;
//             totalScore: number;
//         }>(`${this.API_URL}/finalScore`);
//     }

//     // ✅ Nieuwe functie: Haal de gameStarted-status op
//     public async fetchGameStarted(): Promise<boolean> {
//         console.log("Fetching gameStarted status...");

//         const response: {
//             gameStarted: boolean;
//         } = await this.getJsonApi<{ gameStarted: boolean }>(`${this.API_URL}/game-started`);
//         return response.gameStarted;
//     }
// }
